<template>
  <BaseFilter
    :title="`${tripModule.trip} Filter`"
    @submit="$emit('apply')"
    @reset="$emit('reset')"
    :isChips="isChips"
    newClass="pa-0 ma-0 btn-box background_color primary--text"
    iconSize="15"
    @filterDialogOpen="getTripOptions"
  >
    <template #form>
      <v-form ref="tripFilterForm">
        <v-row no-gutters class="pt-4 px-4 background-grey">
          <v-col cols="12">
            <SelectField
              id="trip_status"
              name="trip_status"
              outlined
              dense
              :menu-props="{ offsetY: true }"
              :itemsList="statusTypes"
              :label="`select ${statusMapping.tripStatus}`"
              itemText="display_value"
              itemValue="value"
              :multiple="true"
              v-model="tripFilters.status"
              class="mb-4 background-white"
              @change="tripFiltersChanged('status', $event)"
            ></SelectField>
          </v-col>
        </v-row>
        <v-row no-gutters class="pb-4 pt-2 px-4 background-white">
          <v-col cols="12" class="px-1 pb-1 mb-4 border-bottom-black">
            <span
              class="text-subtitle-1 font-weight-bold text-grey text-capitalize"
            >
              filter by date range
            </span>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            xl="6"
            :class="`pb-4 ${$vuetify.breakpoint.lgAndUp ? 'pr-2' : null}`"
          >
            <DatePicker
              id="start_date"
              name="start_date"
              :value="tripFilters.from_date"
              type="date"
              label="start date"
              outlined
              dense
              @change="tripFiltersChanged('from_date', $event)"
            ></DatePicker>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            xl="6"
            :class="`pb-4 ${$vuetify.breakpoint.lgAndUp ? 'pl-2' : null}`"
          >
            <DatePicker
              id="end_date"
              name="end_date"              :value="tripFilters.to_date"
              type="date"
              label="end date"
              outlined
              dense
              @change="tripFiltersChanged('to_date', $event)"
            ></DatePicker>
          </v-col>
          <v-col cols="12">
            <SelectField
              id="sort_by"
              name="sort_by"
              clearable
              label="sort by"
              :itemsList="sortBy"
              :value="tripFilters.ordering"
              :menu-props="{ offsetY: true }"
              @change="tripFiltersChanged('ordering', $event)"
              :isSearchRequired="false"
            ></SelectField>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFilter>
</template>

<script>
import { bus } from "@/main";
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { mapState } from "vuex";
import { tripModule, statusMapping } from "@/utils/moduleMapping";
export default {
  components: {
    BaseFilter,
  },
  props: {
    value: Boolean,
    isChips: Boolean,
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState("userProfile", {
      tripFilters: (state) => state.trip_filters,
    }),
  },
  data() {
    return {
      statusMapping,
      tripModule,
      projectList: [],
      statusTypes: [],
      sortBy: [
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Status (Descending)",
          value: "-status",
        },
        {
          text: "Weight",
          value: "total_order_weight",
        },
        {
          text: "Weight (Descending)",
          value: "-total_order_weight",
        },
        {
          text: "Volume",
          value: "total_order_cbm",
        },
        {
          text: "Volume (Descending)",
          value: "-total_order_cbm",
        },
        {
          text: "Reference Number",
          value: "reference_number",
        },
        {
          text: "Reference Number (Descending)",
          value: "-reference_number",
        },
        {
          text: "Trip Date",
          value: "trip_date",
        },
        {
          text: "Trip Date (Descending)",
          value: "-trip_date",
        },
        {
          text: "Driver Name",
          value: "driver",
        },
        {
          text: "Driver Name (Descending)",
          value: "-driver",
        },
      ],
    };
  },
  methods: {
    getTripOptions() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripOptions({ request_type: "filter" })
        .then((res) => {
          this.statusTypes = res?.data?.status;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    tripFiltersChanged(key, value) {
      let obj = {};
      obj[key] = value;
      this.$store.commit("userProfile/setFilters", {
        moduleKey: "trip_filters",
        payload: obj,
      });
    },
  },
};
</script>
